import { toastError } from 'src/Toaster/Toast';
import { Segment } from 'src/types/shared/blocksV3';

function validateSelectedVacantSegment(segment: Segment, defaultSize: number) {
	if (segment.length < defaultSize) {
		toastError({
			title: 'Edge too short',
			description: `Selected segment (${segment.length / 12} ft)   cannot accomodate a new block  (${defaultSize / 12} ft)`,
		});
		return;
	}

	return segment;
}

export default validateSelectedVacantSegment;
